const sxStyles = ({ spacing, palette }) => {
    return {
        root: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: palette.mode === "dark" ? palette.primary.contrastText : palette.primary.main,
        },
        logoLink: {
            fontSize: 0, // Safari has issue with display: inline-flex;
            color: "primary.main",
        },
        logo: {
            width: spacing(3),
            height: spacing(3),
        },
    };
};
export default sxStyles;
//# sourceMappingURL=Logo.style.js.map